<div class="fab-container" [class.has-chat]="hasChat">
  <button
    (click)="clicked.emit()"
    *ngIf="icon"
    [matTooltip]="tooltip"
    class="button-icon"
    mat-fab
    matTooltipPosition="left"
  >
    <app-icon [name]="icon"></app-icon>
  </button>
  <button
    (click)="clicked.emit()"
    *ngIf="text"
    [matTooltip]="tooltip"
    class="button-text"
    mat-fab
    matTooltipPosition="left"
  >
    {{ text }}
  </button>
</div>
